var _style, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPointCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n    .circle {\n      fill: white;\n      opacity: 0.4;\n      transition: r 0.3s ease, fill 0.3s ease;\n    }\n    .circle:hover {\n      fill: #FFFF10;\n      opacity: 0.8;\n    }\n  ")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "circle",
    cx: 10,
    cy: 10,
    r: 5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPointCircle);
export default __webpack_public_path__ + "static/media/point-circle.0bed1110ac17552100850ac05bb3eaad.svg";
export { ForwardRef as ReactComponent };